import React from 'react';

// Function to generate a random color with good contrast for text
const getRandomColor = () => {
  // Generate random hue (0-360)
  const hue = Math.floor(Math.random() * 360);
  // Keep saturation between 50-100% for vibrant colors
  const saturation = 70 + Math.floor(Math.random() * 30);
  // Keep lightness between 30-80% for good contrast
  const lightness = 40 + Math.floor(Math.random() * 40);
  
  return {
    backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
    // Calculate text color based on background brightness
    color: lightness < 60 ? '#ffffff' : '#000000'
  };
};

const CouponCard = ({ coupon, onClick }) => {
  const colors = getRandomColor();
  const isDiscount = coupon.type === 'discount';
  
  return (
    <div 
      className="card mb-3 cursor-pointer hover-shadow transition-all"
      onClick={onClick}
      style={{
        borderLeft: `4px solid ${colors.backgroundColor}`,
        borderRadius: '8px',
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        backgroundColor: `${colors.backgroundColor}10`,
        border: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    >
      <div className="card-body p-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5 
              className="card-title mb-1 fw-bold" 
              style={{ color: 'black' }}
            >
              {coupon.title}
            </h5>
            
          </div>
          <div className="text-end">
            <div 
              className=" fw-bold text-center"
              style={{
                backgroundColor: colors.backgroundColor,
                color: colors.color,
                border: `1px solid ${colors.color}80`,
                fontSize: '0.9rem',
                borderRadius: '6px',
                minWidth: '80px'
              }}
            >
              {isDiscount ? (
                <>
                  <div style={{ fontSize: '1.1rem' }}>{coupon.value}%</div>
                  <div style={{ fontSize: '0.7rem', opacity: 0.9 }}>DESCUENTO</div>
                </>
              ) : (
                <div style={{ fontSize: '0.9rem' }}>{coupon.value}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponCard;